import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class ProposedValuationOwner extends React.Component {
  static contextType = FilterContext;

  state = {
    cities: {},
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_owner_city_presence",
        BodyAsFormData(filters)
      )
      .then((res) => {
        console.log(res);
        this.setState({ cities: res.data });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_owner_city_presence",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ cities: res.data });
        });
    }
  }

  render() {
    return (
      <div class="widget widgetDeveloperRight">
        <div class="row">
          <div className="col-lg-12 text-end">
            <p>
              <Link to="/#" className="colorBlack">
                <FontAwesomeIcon icon={faEllipsisV} />
              </Link>
            </p>
          </div>
          <div class="col-lg-12 flexCenter">
            <img
              alt="Current Coverage Icon"
              src="/edge/images/current_coverage.png"
              class="imgWidth100"
            />
          </div>
          <div class="col-lg-12 text-center colorBlue">
            <h1>{this.state.cities.no_of_cities}</h1>
            {/* <p>(21 Assets)</p> */}
            <p class="widgetName">Presence (Cities) </p>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(ProposedValuationOwner);
